import axios from 'axios'
import Adapter from 'axios-mock-adapter'
import { get } from 'lodash'
import { errorLog, errorCreate } from './tools'
import store from '@/store'
import router from '@/router'
import { getToken } from '@/libs/util.token'
import { getLang } from '@/libs/util.lang'

/**
 * @description 创建请求实例
 */
function createService() {
  // 创建一个 axios 实例
  const service = axios.create()
  // 请求拦截
  service.interceptors.request.use(
    (config) => config,
    (error) => {
      // 发送失败
      console.log(error)
      return Promise.reject(error)
    }
  )
  // 响应拦截
  service.interceptors.response.use(
    (response) => {
      // dataAxios 是 axios 返回数据中的 data
      const dataAxios = response.data
      // 这个状态码是和后端约定的
      const { status } = dataAxios
      // 根据 code 进行判断
      if (status === undefined) {
        // 如果没有 status 代表这不是项目后端开发的接口
        return dataAxios
      } else {
        // 有 code 代表这是一个后端接口 可以进行进一步的判断
        switch (status) {
          case 201:
            // [ 示例 ] 其它和后台约定的 status
            errorCreate(`${dataAxios.msg}`)
            break
          case 202:
            errorCreate(`${dataAxios.msg}`)
            break
          case 500:
            errorCreate(`${dataAxios.msg}`)
            break
          case 401:
            logout()
            break
          case 403:
            logout()
            break
          default:
            return dataAxios
        }
      }
    },
    (error) => {
      const status = get(error, 'response.status')
      switch (status) {
        case 400:
          error.message = '请求错误'
          break
        case 401:
          error.message = '未授权，请登录'
          logout()
          break
        case 403:
          error.message = '拒绝访问'
          if (router.app.$route.name !== '403') {
            router.replace({ name: '403' })
          }
          break
        case 404:
          error.message = `请求地址出错: ${error.response.config.url}`
          break
        case 408:
          error.message = '请求超时'
          break
        case 500:
          error.message = '服务器内部错误'
          break
        case 501:
          error.message = '服务未实现'
          break
        case 502:
          error.message = '网关错误'
          break
        case 503:
          error.message = '服务不可用'
          break
        case 504:
          error.message = '网关超时'
          break
        case 505:
          error.message = 'HTTP版本不受支持'
          break
        default:
          break
      }
      errorLog(error)
      return Promise.reject(error)
    }
  )
  return service
}

/**
 * @description 创建请求方法
 * @param {Object} service axios 实例
 */
function createRequestFunction(service) {
  return function(config) {
    const token = getToken()
    const language = getLang()
    const appName = 'pla'
    const configDefault = {
      headers: {
        Authorization: token || '',
        language: language,
        'Content-Type': get(config, 'headers.Content-Type', 'application/json'),
      },
      timeout: 10000,
      baseURL: config.baseURL || process.env.VUE_APP_API,
      data: {},
    }
    if (config.data) {
      config.data.token = token
      config.data.appName = appName
      config.data.language = language
    } else {
      config.data = {
        token: token,
        appName: appName,
        language: language,
      }
    }
    return service(Object.assign(configDefault, config))
  }
}

function logout() {
  if (router.app.$route.name !== 'login') {
    store.dispatch('admin/account/logout')
  }
}

// 用于真实网络请求的实例和请求方法
export const service = createService()
export const request = createRequestFunction(service)

// 用于模拟网络请求的实例和请求方法
export const serviceForMock = createService()
export const requestForMock = createRequestFunction(serviceForMock)

// 网络请求数据模拟工具
export const mock = new Adapter(serviceForMock)
